export default {
  id: '',
  categoryDesc: '',
  
};
